export default {
  /// <summary>
  /// Download
  /// </summary>
  Download: 0,
  /// <summary>
  /// Preview
  /// </summary>
  Preview: 1
};
